<template>
    <div class="table-header">
        <span class="table-header__column" data-column="title" v-text="'Name'"/>
        <span class="table-header__column" data-column="deal_type" v-text="'Deal Type'"/>
        <span class="table-header__column" data-column="value" v-text="'Value'"/>
        <span class="table-header__column" data-column="sector" v-text="'Main Sector'"/>
        <button
            class="table-header__column"
            data-column="completed"
            @click.prevent.stop="changeSort"
        >
            <span v-text="'Completed'"/>
            <svg
                v-if="sort && (sort === 'asc' || sort === 'desc')"
                :class="{
                    'svg-icon': true,
                    'sort-icon': true,
                    'sort': true,
                    'sort--asc' : this.sort && this.sort === 'asc',
                    'sort--desc' : this.sort && this.sort === 'desc',
                }"
            >
                <use xlink:href="#icon--sort"></use>
            </svg>
        </button>
    </div>
</template>
<script>
import debounce from 'debounce';

export default {
    name: 'MADDTableHeader',
    data: () => ({
        sort: null,
    }),
    methods: {
        changeSort() {
            switch(this.sort) {
                case 'asc':
                    this.sort = null;
                    break;
                case 'desc':
                    this.sort = 'asc';
                    break;
                default:
                    this.sort = 'desc';
                    break;
            }
        },
    },
    watch: {
        sort: {
            handler: debounce(function() {
                this.$emit('changeSort', this.sort);
            }, 650), // 500ms delay
            immediate: false
        }
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.table-header {
    .table-header__column {
        &[data-column="title"] {
            flex: 1 1 auto;
            max-width: calc((((100% - 18rem) - 18rem) - 9rem) - 10.2rem);
        }

        &[data-column="deal_type"] {
            flex: 0 0 18rem;
        }

        &[data-column="value"] {
            flex: 0 0 9rem;
        }

        &[data-column="sector"] {
            flex: 0 0 18rem;
        }

        &[data-column="completed"] {
            flex: 0 0 9rem;
            text-align: right;
            justify-content: flex-end;
        }
    }

    @media screen and (max-width: 991px) {
        display: none !important;
    }
}
</style>
